var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, html, css } from 'lit';
import { customElement, property, state } from 'lit/decorators.js';
import { msg, localized } from '@lit/localize';
import { CommonActions } from '../../localization/helpers.js';
let InputFile = class InputFile extends LitElement {
    constructor() {
        super(...arguments);
        this.fileTypes = [];
        this.multiple = false;
        this.label = '';
        this.selectedFiles = [];
        this.isDragging = false;
    }
    render() {
        const accept = this.fileTypes.join(',');
        return html `
      <div class="container">
        <div
          class="drop-zone ${this.isDragging ? 'dragging' : ''}"
          @dragover=${this.handleDragOver}
          @dragleave=${this.handleDragLeave}
          @drop=${this.handleDrop}
          @click=${this.triggerFileInput}
        >
          <span>${this.label || msg('Choose file', { id: 'form.file.choose', desc: 'File chooser label' })}</span>
          <input
            type="file"
            ?multiple=${this.multiple}
            accept="${accept}"
            @change=${this.handleFileSelect}
          />
        </div>

        ${this.selectedFiles.length > 0
            ? html `
              <div class="file-list">
                ${this.selectedFiles.map((file, index) => html `
                    <div class="file-item">
                      <span title="${file.name}">• ${file.name}</span>
                      <button @click=${() => this.removeFile(index)}>${CommonActions.delete()}</button>
                    </div>
                  `)}
              </div>
            `
            : null}
      </div>
    `;
    }
    handleFileSelect(e) {
        const input = e.target;
        if (!input.files)
            return;
        const files = Array.from(input.files);
        this.updateSelectedFiles(this.multiple ? [...this.selectedFiles, ...files] : files);
        // Réinitialiser input pour permettre re-sélection du même fichier
        input.value = '';
    }
    handleDragOver(e) {
        e.preventDefault();
        this.isDragging = true;
    }
    handleDragLeave(e) {
        // Empêche le flicker lorsque le curseur est toujours dans le drop-zone
        if (!this.shadowRoot?.elementFromPoint(e.clientX, e.clientY)?.classList.contains('drop-zone')) {
            this.isDragging = false;
        }
    }
    handleDrop(e) {
        e.preventDefault();
        this.isDragging = false;
        if (e.dataTransfer?.files) {
            const files = Array.from(e.dataTransfer.files);
            this.updateSelectedFiles(this.multiple ? [...this.selectedFiles, ...files] : files);
        }
    }
    triggerFileInput() {
        const input = this.shadowRoot?.querySelector('input[type="file"]');
        if (input) {
            input.click();
        }
    }
    updateSelectedFiles(files) {
        if (this.multiple) {
            const existingFileNames = new Set(this.selectedFiles.map((file) => file.name));
            const newFiles = files.filter((file) => !existingFileNames.has(file.name));
            this.selectedFiles = [...this.selectedFiles, ...newFiles];
        }
        else {
            this.selectedFiles = files;
        }
        this.dispatchEvent(new CustomEvent('file-selected', {
            detail: this.selectedFiles,
            bubbles: true,
            composed: true,
        }));
    }
    removeFile(index) {
        this.selectedFiles = this.selectedFiles.filter((_, i) => i !== index);
        // Emit updated files
        this.dispatchEvent(new CustomEvent('file-selected', {
            detail: this.selectedFiles,
            bubbles: true,
            composed: true,
        }));
    }
};
InputFile.styles = css `
    :host {
      display: block;
      font-family: inherit;
      width: 100%;
    }

    .container {
      display: flex;
      flex-direction: column;
      gap: 10px;
      width: 100%;
      overflow: hidden; /* Empêche le débordement */
    }

    .drop-zone {
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 20px;
      border: 2px dashed #007bff;
      border-radius: 6px;
      background: #f9f9f9;
      transition: background 0.2s, border-color 0.2s;
      text-align: center;
      cursor: pointer;
      width: 100%;
      box-sizing: border-box;
    }

    .drop-zone.dragging {
      background: #e6f7ff;
      border-color: #0056b3;
    }

    .drop-zone input[type="file"] {
      display: none;
    }

    .file-list {
      font-size: 0.85rem;
      color: #555;
    }

    .file-item {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-top: 5px;
      padding: 5px;
      border: 1px solid #ddd;
      border-radius: 4px;
      background: #fff;
      max-width: 100%;
      box-sizing: border-box;
    }

    .file-item span {
      flex: 1;
      min-width: 0; /* Permet au texte de se tronquer dans un flex container */
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .file-item button {
      background: none;
      border: none;
      color: #ff4d4f;
      cursor: pointer;
      font-size: 0.85rem;
    }

    .file-item button:hover {
      text-decoration: underline;
    }
  `;
__decorate([
    property({ type: Array })
], InputFile.prototype, "fileTypes", void 0);
__decorate([
    property({ type: Boolean })
], InputFile.prototype, "multiple", void 0);
__decorate([
    property({ type: String })
], InputFile.prototype, "label", void 0);
__decorate([
    state()
], InputFile.prototype, "selectedFiles", void 0);
__decorate([
    state()
], InputFile.prototype, "isDragging", void 0);
InputFile = __decorate([
    localized(),
    customElement('input-file')
], InputFile);
export { InputFile };
//# sourceMappingURL=InputFile.js.map